import groupBy from 'lodash/groupBy';
import { arrayOf, shape, string } from 'prop-types';
import React from 'react';

import Swimlanes from '../../layout/Swimlanes';
import Titled from '../../layout/Titled';
import { basicCampaignShape, campaignBudgetsShape } from '../../prop-types';
import api from '../../REST/api';
import withResolved from '../../REST/with-resolved';
import BudgetData from '../BudgetData';
import CampaignLane from '../CampaignLane';
import withCampaignsAsData from '../with-campaigns-as-data';

class SwimlaneCampaigns extends React.PureComponent {
  render() {
    const { categories, data, budgets, groupBy: groupByKey } = this.props;
    const groupedData = groupBy(data, groupByKey);

    return (
      <Titled
        title={
          <BudgetData
            openBudget={budgets.openBudget}
            securedBudget={budgets.securedBudget}
            securedPushedBudget={budgets.securedPushedBudget}
            openChangeRequests={budgets.openChangeRequests}
          />
        }
        size="reg"
        noPadding
      >
        <Swimlanes className="c-swimlane-wrapper">
          {categories.map(category => (
            <CampaignLane
              key={category.value}
              category={category}
              campaigns={groupedData[category.value] || []}
            />
          ))}
        </Swimlanes>
      </Titled>
    );
  }
}

SwimlaneCampaigns.propTypes = {
  categories: arrayOf(
    shape({
      label: string.isRequired,
      value: string.isRequired,
    }).isRequired,
  ).isRequired,
  data: arrayOf(basicCampaignShape.isRequired),
  groupBy: string.isRequired,
  budgets: campaignBudgetsShape.isRequired,
};

SwimlaneCampaigns.defaultProps = {
  data: [],
};

export { SwimlaneCampaigns };

export default withResolved({
  query: api.getCampaignBudgets,
  deriveQueryArgs: ({ relevantFor, relevantForSalesTeam }) => ({
    search: { relevantFor, relevantForSalesTeam },
  }),
  as: 'budgets',
})(withCampaignsAsData(SwimlaneCampaigns, true));
